import { LAB_URL,FORTIFICATION_URL, FORTIFICATION_URL_RICE, LAB_URL_RICE, IAM_URL, IAM_URL_RICE } from "../url";
import HttpService from "./HttpService";
const _axios = HttpService.getAxiosClient();


export const labTestReferenceAllMethods = async (categoryId, params) => {
  return _axios
    .get(`${LAB_URL}method/allMethods/${categoryId}`, {params})
    .catch((error) => {});
};
export const getLabById = async (lab_id) => {
  return _axios.get(`${LAB_URL}${lab_id}`).catch((error) => {});
};
export const getAllLabs = async () => {
  return _axios.get(`${LAB_URL}`).catch((error) => {});
};
export const getActionsButton = async (categoryId, batchId, type,stateName) => {
  return _axios
    .get(`${FORTIFICATION_URL}${categoryId}/${type}/${batchId}/actions/lab?sampleState=${stateName}`)
    .catch((error) => {});
};
export const getRowDataLab = async (payload, pageNumber, pageSize) => {
  const sessionLabId = sessionStorage.getItem("labId");
  return _axios
    .post(
      `${LAB_URL}${sessionLabId}/sample/list?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      payload
    )
    .catch((error) => {});
};

export const resetPassword = async (id, body) => {
  return _axios
    .put(`${IAM_URL_RICE}user/${id}/reset-password`, body)
    .catch((error) => {
      console.log(error);
    });
};


export const getAllLabTestsByCategoryId = async (payload, pageNumber, pageSize) => {
  const sessionLabId = sessionStorage.getItem("labId");
  return _axios
    .post(
      `${LAB_URL}admin/samples?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      payload
    )
    .catch((error) => {});
};

export const createBatch = async (categoryId, body) => {
  return _axios
    .post(`${LAB_URL}${categoryId}/batch`, body)
    .then(function (response) {})

    .catch((error) => {});
};
export const getSampleDocs = async (sampleId) => {
  const sessionLabId = sessionStorage.getItem("labId");
  return _axios
    .get(`${LAB_URL}${sessionLabId}/sample/${sampleId}`)
    .catch((error) => {});
};

export const uploadFile = async (body) => {
  const formData = new FormData();
  formData.append("file", body[0]);
  return _axios.post(`${LAB_URL}storage/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateLabSamples = async (sampleId, body, callBack) => {
  const sessionLabId = sessionStorage.getItem("labId");
  return _axios
    .put(`${LAB_URL}${sessionLabId}/sample/${sampleId}`, body)
    .catch((error) => {
      callBack(error);
    });
};

export const getSpecificSampleDetail = async (sampleId) => {
  const sessionLabId = sessionStorage.getItem("labId");
  return _axios
    .get(`${LAB_URL}${sessionLabId}/sample/${sampleId}`)
    .catch((error) => {});
};

export const updateStateAction = async (categoryId, batchId, payload) => {
  return _axios
    .post(`${FORTIFICATION_URL}${categoryId}/batch/${batchId}/state/lab`, payload)
    .catch((error) => {});
};

export const createLabTest = async (body) => {
  return _axios.post(`${LAB_URL}{labId}/sample`, body).catch((error) => {});
};
export const getSampleDocRequirements = async (categoryId) => {
  return _axios
    .get(`${LAB_URL}document/${categoryId}/sample/requirements`)
    .catch((error) => {});
};

export const getMenuItems = async () => {
  return _axios.get(`${FORTIFICATION_URL_RICE}menu/lab`).catch((error) => {});
};

export const UpdateLabStates = async (labId, sampleId, buttonText, date, categoryId) => {
  return _axios
    .get(
      `${LAB_URL}${labId}/sample/${sampleId}/state?state=${buttonText}&date=${date}&categoryId=${categoryId}`
    )
    .catch((error) => {});
};
